export default __webpack_public_path__ + "static/media/expiredQr_eng.08afc81b.png";